import { validationMixin } from 'vuelidate';
import formCaptcha from '@/components/forms/captcha/captcha.vue';
import formCheckbox from '@/components/forms/checkbox/checkbox.vue';
import formErrors from '@/components/forms/errors/errors.vue';
import formInput from '@/components/forms/input/input.vue';
import formRadio from '@/components/forms/radio/radio.vue';
import formSelect from '@/components/forms/select/select.vue';
import formSocials from '@/components/forms/socials/socials.vue';
import formSubmit from '@/components/forms/submit/submit.vue';
import formTextarea from '@/components/forms/textarea/textarea.vue';
import passwordRequirements from '@/components/forms/password-requirements/password-requirements.vue';
import showPasswordIcon from '@/components/show-password-icon/show-password-icon.vue';
import validators from '@/helpers/validators';
import { isIos } from '@/mixins/userAgent';

const ERROR_GENERIC = 'There was an error processing your request. Please try again.';
const ERROR_UNAUTHORIZED = '401 Unauthorized';
const ERROR_UNAUTHORIZED_MESSAGE = 'This account has been closed.';

const formMixin = {
  components: {
    formCaptcha,
    formCheckbox,
    formErrors,
    formInput,
    formRadio,
    formSelect,
    formSocials,
    formSubmit,
    formTextarea,
    passwordRequirements,
    showPasswordIcon,
  },
  mixins: [
    validationMixin,
  ],
  data() {
    return {
      errors: [],
      fields: {
      },
      isFormEnabled: true,
    };
  },
  computed: {
    isFormDisabled() {
      return this.isFormEnabled === false;
    },
    invalidOrDisabled() {
      return this.$v.$invalid || !this.isFormEnabled;
    },
  },
  methods: {
    formIsValid() {
      return !this.$v.$invalid;
    },
    formEnable() {
      this.isFormEnabled = true;
    },
    formDisable() {
      this.formReset();
      this.isFormEnabled = false;
      return true;
    },
    formReset() {
      this.errors = [];
    },
    formHandleErrors(error) {
      this.formEnable();
      try {
        if (error && error.response && error.response.data) {
          if (error.response.data instanceof Array) {
            error.response.data.forEach(e => this.errors.push(e.message));
          } else if (error.response.data.error_description) {
            let description = error.response.data.error_description;
            if (typeof description === 'string') {
              description = JSON.parse(description);
            }
            description.forEach(e => this.errors.push(e.Message));
          } else if (error.response.data.message) {
            this.errors.push(error.response.data.message);
          } else if (error.response.data.error) {
            if (error.response.data.error === ERROR_UNAUTHORIZED) {
              this.errors.push(ERROR_UNAUTHORIZED_MESSAGE);
            } else {
              this.errors.push(error.response.data.error);
            }
          }
        }
      } catch (e) {
        this.errors.push(ERROR_GENERIC);
      }

      if (isIos) {
        this.$el.scrollIntoView(true);
      }
    },
    tabTo(e, next) {
      if (e) {
        if (!this.$refs[next]) return;
        const input = this.$refs[next].$el.getElementsByTagName('input')[0];
        if (input) {
          input.focus();
        }
      }
    },
  },
};

export { validators, formMixin };
export default formMixin;



// WEBPACK FOOTER //
// ./src/components/forms/mixin.js